import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
import { WalletAccount } from '@exodus/models';
const resultFunction = (get) => (name) => get(name)?.source === WalletAccount.FTX_SRC;
const isFTXSelector = defineSelectorResultFunction({
    id: 'isFTX',
    resultFunction,
    dependencies: [
        { selector: 'get' },
    ],
});
export default isFTXSelector;
